import { useEffect, useRef, useState } from 'react';
import { useTranslations } from '@/i18n/use-translations';
import { signOut } from '@/lib/auth/session';

export function SignOutPage() {
  const t = useTranslations('pages.admin.sign-out');
  const [error, setError] = useState<string | null>(null);
  // Guard against React StrictMode's dev double-mount: useRef survives the
  // remount on the same component instance, so the second effect run sees
  // `startedRef.current === true` and skips. Fresh renders (e.g. between
  // tests) get a new ref, so this never leaks across mounts.
  const startedRef = useRef(false);

  useEffect(() => {
    if (startedRef.current) return;
    startedRef.current = true;

    (async () => {
      try {
        const url = await signOut();
        window.location.assign(url);
      } catch {
        startedRef.current = false;
        setError(t('failed'));
      }
    })();
  }, [t]);

  return (
    <main className="flex min-h-screen items-center justify-center bg-canvas p-6">
      <div className="space-y-4 text-center">
        {error === null ? (
          <p className="text-base text-text-tertiary">{t('loading')}</p>
        ) : (
          <>
            <p className="text-base text-danger-600">{error}</p>
            <a href="/sign-in" className="text-base text-interactive underline-offset-4 hover:underline">
              {t('back-to-sign-in')}
            </a>
          </>
        )}
      </div>
    </main>
  );
}
